import { insertText } from '@udecode/plate-common'
import { createPlatePlugin, TPlateEditor } from '@udecode/plate-common/react'

import { isCodeBlockElement } from '../utils/helpers'

/**
 * Preserves whitespace when pasting into code blocks.
 *
 * By default, Plate's HtmlPlugin collapses whitespace (like browsers do with HTML).
 * This plugin intercepts paste events when inside a code block and inserts the
 * plain text directly, preserving indentation and formatting.
 */
export const PasteCodeBlockPlugin = createPlatePlugin({
    key: 'pasteCodeBlock',
    extendEditor: ({ editor }: { editor: TPlateEditor }) => {
        const { insertData } = editor

        editor.insertData = (data) => {
            if (isCodeBlockElement(editor)) {
                const text = data.getData('text/plain')
                if (text) {
                    insertText(editor, text)
                    return
                }
            }

            insertData(data)
        }

        return editor
    },
})
